import React, { useState, useEffect } from 'react'
import DefaultLevel from '../defaultLevel/DefaultLevel'
import { Collapse } from 'react-bootstrap'
import styles from './FirstLevel.module.scss'
import CheckBoxRadioButtonInput from 'components/ui/forms/field/checkbox-radiobutton/CheckBoxRadioButtonInput'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronUp,
  faChevronDown,
  faFolderOpen,
} from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'

export interface IFirstLevel {
  id: number
  name: string
  blocks: any[]
  onFirstLevelCheck: any
  onDefaultLevelCheck: any
  checked: any
  addRef: any
}

const FirstLevel: React.FC<IFirstLevel> = ({
  id,
  name,
  blocks,
  onFirstLevelCheck,
  onDefaultLevelCheck,
  checked,
  addRef,
}) => {
  const { t } = useTranslation()
  const [collapse, setCollaspe] = useState(false)
  const [isChecked, setIsChecked] = useState(true)
  const [blocksCheckList, setBlocksCheckList] = useState([] as any)

  useEffect(() => {
    const getLesson = checked.find((lesson: any) => lesson.lessonId === id)
    setIsChecked(getLesson ? getLesson.checked : false)
    if (getLesson && getLesson.blocks.length >= 0) {
      setBlocksCheckList(getLesson.blocks.slice())
    }
  }, [checked, id])

  const handleCollapse = (e: any) => {
    if (e.target != document.getElementById('custom-control'))
      setCollaspe(!collapse)
  }

  const handleTruncateName = (text: string) => {
    if (text.length < 75) return text

    const aux = text.substr(0, 75)
    const space = aux.lastIndexOf(' ')

    if (space < 0) return aux + '...'

    return aux.substr(0, space) + '...'
  }

  return (
    <>
      <a
        id={'collapseHandler' + id}
        className={styles.container}
        onClick={handleCollapse}
      >
        <div className={'lessonNameContainer'} ref={addRef}>
          <CheckBoxRadioButtonInput
            name={'lesson' + id}
            value={false}
            label=""
            inline={false}
            type="checkbox"
            onChange={() => onFirstLevelCheck(id)}
            checked={isChecked}
          />
          <span className={styles.lessonName}>
            {name.trim() === ''
              ? `[${t('administration.courses.duplicate.noNameLesson')}]`
              : handleTruncateName(name)}
          </span>
        </div>

        <div>
          <FontAwesomeIcon icon={collapse ? faChevronUp : faChevronDown} />
        </div>
      </a>
      <Collapse in={collapse}>
        <div>
          <div className={styles.blocks}>
            {blocks.length > 0 ? (
              blocks.map(({ id, type, name }: any) => (
                <DefaultLevel
                  key={'defaultLevel' + id}
                  id={id}
                  name={name}
                  type={type}
                  checked={blocksCheckList}
                  onCheck={onDefaultLevelCheck}
                />
              ))
            ) : (
              <div className={styles.emptyList}>
                <FontAwesomeIcon icon={faFolderOpen} className="mr-2" />
                {t('administration.courses.duplicate.emptyBlockList')}
              </div>
            )}
          </div>
        </div>
      </Collapse>
    </>
  )
}

export default FirstLevel
